module.exports = "//__CDN_HOST__/2.0.8/img/about.c231dc28.png";